import http from "src/config/interceptors"
export interface ChargeCloverType {
  paymentToken: string
  cardToken: string
}

export const getPaymentToken = (paymentToken: string) => {
  return http.get(`/payment/v2/payments/token/${paymentToken}`)
}

export const getPaymentType = (paymentToken: string) => {
  return http.get(`/payment/payment-type/${paymentToken}`)
}

export const charge = (paymentToken: string) => {
  return http.post(
    `/payment/payments/stripe/charge?payment_token=${paymentToken}`
  )
}
export const getPublicKey = () => {
  return http.get("/payment/payments/stripe/public-key")
}
export const getCloverPublicKey = () => {
  return http.get("/payment/payments/CLOVER/public-key")
}

export const gatewayCharge = (paymentToken: string, paymentType: string) => {
  return http.post(
    `/payment/payments/${paymentType}/charge?payment_token=${paymentToken}`
  )
}
export const gatewayCloverCharge = (paymentToken: string) => {
  return http.post(
    `/payment/payments/CLOVER/charge?payment_token=${paymentToken}`
  )
}

export const getPaymentGateway = () => {
  return http.get("/payment/payment-gateway")
}

export const chargeClover = (chargeRequest: ChargeCloverType) => {
  const data = {
    token: chargeRequest.paymentToken,
    card_token: chargeRequest.cardToken,
    args: [],
  }
  return http.post("/payment/payments/CLOVER/charge-direct", data)
}
